const map = {
	"./AD.svg": 5526,
	"./AE.svg": 45063,
	"./AF.svg": 57204,
	"./AG.svg": 18485,
	"./AL.svg": 3038,
	"./AM.svg": 65615,
	"./AN.svg": 86588,
	"./AO.svg": 15133,
	"./AR.svg": 55320,
	"./AT.svg": 87590,
	"./AU.svg": 50391,
	"./AW.svg": 23813,
	"./AZ.svg": 28832,
	"./BA.svg": 72686,
	"./BB.svg": 67053,
	"./BD.svg": 88339,
	"./BE.svg": 57762,
	"./BF.svg": 38161,
	"./BG.svg": 97600,
	"./BH.svg": 2807,
	"./BI.svg": 40006,
	"./BJ.svg": 76229,
	"./BN.svg": 83241,
	"./BO.svg": 7736,
	"./BR.svg": 67549,
	"./BS.svg": 39004,
	"./BT.svg": 83011,
	"./BV.svg": 15361,
	"./BW.svg": 560,
	"./BY.svg": 57942,
	"./BZ.svg": 70901,
	"./CA.svg": 43613,
	"./CD.svg": 2480,
	"./CF.svg": 9682,
	"./CG.svg": 63971,
	"./CH.svg": 7540,
	"./CI.svg": 33173,
	"./CL.svg": 59240,
	"./CM.svg": 83513,
	"./CN.svg": 22762,
	"./CO.svg": 40603,
	"./CR.svg": 5230,
	"./CU.svg": 14225,
	"./CV.svg": 59682,
	"./CW.svg": 22323,
	"./CY.svg": 38501,
	"./CZ.svg": 39366,
	"./DE.svg": 7052,
	"./DJ.svg": 98347,
	"./DK.svg": 95642,
	"./DM.svg": 36196,
	"./DO.svg": 91782,
	"./DZ.svg": 93019,
	"./EC.svg": 75557,
	"./EE.svg": 62251,
	"./EG.svg": 13193,
	"./ER.svg": 36692,
	"./ES.svg": 74677,
	"./ET.svg": 45578,
	"./FI.svg": 48658,
	"./FJ.svg": 41793,
	"./FM.svg": 28414,
	"./FR.svg": 15113,
	"./GA.svg": 67529,
	"./GB.svg": 99418,
	"./GD.svg": 9348,
	"./GE.svg": 60517,
	"./GH.svg": 288,
	"./GM.svg": 86093,
	"./GN.svg": 37742,
	"./GQ.svg": 23353,
	"./GR.svg": 48330,
	"./GT.svg": 82580,
	"./GW.svg": 47143,
	"./GY.svg": 94209,
	"./HK.svg": 15190,
	"./HN.svg": 98491,
	"./HR.svg": 67871,
	"./HT.svg": 95409,
	"./HU.svg": 38496,
	"./ID.svg": 82350,
	"./IE.svg": 20287,
	"./IL.svg": 49670,
	"./IN.svg": 7876,
	"./IQ.svg": 92675,
	"./IR.svg": 10224,
	"./IS.svg": 25025,
	"./IT.svg": 65118,
	"./JM.svg": 69346,
	"./JO.svg": 77440,
	"./JP.svg": 88711,
	"./KE.svg": 52121,
	"./KG.svg": 71643,
	"./KH.svg": 69404,
	"./KI.svg": 97949,
	"./KM.svg": 52705,
	"./KP.svg": 35556,
	"./KR.svg": 1030,
	"./KW.svg": 19499,
	"./KZ.svg": 40654,
	"./LA.svg": 13848,
	"./LB.svg": 71915,
	"./LC.svg": 78042,
	"./LI.svg": 6592,
	"./LK.svg": 63874,
	"./LR.svg": 24059,
	"./LS.svg": 55242,
	"./LT.svg": 84341,
	"./LU.svg": 46356,
	"./LV.svg": 10919,
	"./LY.svg": 14000,
	"./MA.svg": 81807,
	"./MC.svg": 92253,
	"./MD.svg": 58322,
	"./ME.svg": 72963,
	"./MG.svg": 51457,
	"./MH.svg": 40566,
	"./MK.svg": 12437,
	"./ML.svg": 5578,
	"./MM.svg": 65947,
	"./MN.svg": 15208,
	"./MR.svg": 44396,
	"./MT.svg": 73122,
	"./MU.svg": 78291,
	"./MV.svg": 57536,
	"./MW.svg": 93489,
	"./MX.svg": 95334,
	"./MY.svg": 9719,
	"./MZ.svg": 66596,
	"./NA.svg": 25538,
	"./NE.svg": 47406,
	"./NG.svg": 96812,
	"./NI.svg": 9082,
	"./NL.svg": 62135,
	"./NO.svg": 19012,
	"./NOFLAG.svg": 83898,
	"./NP.svg": 25379,
	"./NR.svg": 3873,
	"./NZ.svg": 33017,
	"./OM.svg": 37813,
	"./PA.svg": 74452,
	"./PE.svg": 26152,
	"./PG.svg": 89674,
	"./PH.svg": 10525,
	"./PK.svg": 72702,
	"./PL.svg": 81633,
	"./PS.svg": 6278,
	"./PT.svg": 8873,
	"./PW.svg": 10138,
	"./PY.svg": 5196,
	"./QA.svg": 65259,
	"./RO.svg": 49416,
	"./RS.svg": 2284,
	"./RU.svg": 21122,
	"./RW.svg": 63840,
	"./SA.svg": 2061,
	"./SB.svg": 2734,
	"./SC.svg": 33727,
	"./SD.svg": 16256,
	"./SE.svg": 30641,
	"./SG.svg": 60915,
	"./SI.svg": 94885,
	"./SK.svg": 52087,
	"./SL.svg": 7160,
	"./SM.svg": 32521,
	"./SN.svg": 87706,
	"./SO.svg": 81579,
	"./SR.svg": 97406,
	"./SS.svg": 33807,
	"./ST.svg": 23664,
	"./SV.svg": 26098,
	"./SX.svg": 56020,
	"./SY.svg": 94005,
	"./SZ.svg": 57366,
	"./TD.svg": 1917,
	"./TG.svg": 47742,
	"./TH.svg": 90265,
	"./TJ.svg": 75611,
	"./TL.svg": 22101,
	"./TM.svg": 49492,
	"./TN.svg": 14055,
	"./TO.svg": 50230,
	"./TR.svg": 87955,
	"./TT.svg": 53005,
	"./TV.svg": 33087,
	"./TZ.svg": 80939,
	"./UA.svg": 21639,
	"./UG.svg": 49433,
	"./US.svg": 389,
	"./UY.svg": 34783,
	"./UZ.svg": 55756,
	"./VA.svg": 17882,
	"./VC.svg": 84312,
	"./VE.svg": 16582,
	"./VI.svg": 34338,
	"./VN.svg": 43629,
	"./VU.svg": 34518,
	"./WS.svg": 22507,
	"./YE.svg": 91055,
	"./ZA.svg": 7478,
	"./ZM.svg": 25234,
	"./ZW.svg": 87448
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42155;